module.exports = __webpack_public_path__ + "img/add-photo.924050a6.svg";